import moment from 'moment'

function multiplyBy100Frontend (numStr) {
  const str = String(numStr)
  const dotIndex = str.indexOf('.')

  if (dotIndex === -1) {
    return parseFloat(str + '00')
  }

  const beforeDot = str.slice(0, dotIndex)
  const afterDot = str.slice(dotIndex + 1)

  if (afterDot.length === 0) {
    return parseFloat(beforeDot + '00')
  }

  const newAfterDot = afterDot.slice(2)
  const newBeforeDot = beforeDot + afterDot.slice(0, 2)

  if (newAfterDot.length === 0) {
    return parseFloat(newBeforeDot)
  }

  return parseFloat(newBeforeDot + '.' + newAfterDot)
}

function divideBy100Frontend (numStr) {
  const str = String(numStr)
  const dotIndex = str.indexOf('.')

  if (dotIndex === -1) {
    const paddedStr = str.padStart(3, '0')
    return parseFloat(paddedStr.slice(0, -2) + '.' + paddedStr.slice(-2))
  }

  const beforeDot = str.slice(0, dotIndex)
  const afterDot = str.slice(dotIndex + 1)
  const combined = (beforeDot + afterDot).padStart(3, '0')
  const newDotPos = combined.length - afterDot.length - 2

  if (newDotPos <= 0) {
    return parseFloat('0.' + combined.padStart(combined.length - newDotPos, '0'))
  }

  return parseFloat(combined.slice(0, newDotPos) + '.' + combined.slice(newDotPos))
}

export function convertToFrontend (value, type) {
  if (type === 'boolean') {
    if (typeof value === 'string') {
    return value.toUpperCase()
    }
  }

  if (type === 'date') {
    if (moment(value).toDate() == 'Invalid Date') {
      return null
    }
    return moment(value).toDate()
  }

  if (type === 'time') {
    return moment(value, 'HH:mm').toDate()
  }

  if (type === 'money') {
    return divideBy100Frontend(value)
  }

  if (type === 'percent') {
    return multiplyBy100Frontend(value)
  }

  if (type === 'number') {
    return parseFloat(value)
  }
  return value
}

function divideBy100 (numStr) {
  const str = String(numStr)
  const dotIndex = str.indexOf('.')

  if (dotIndex === -1) {
    return parseFloat('0.' + str.padStart(2, '0'))
  }

  const beforeDot = str.slice(0, dotIndex)
  const afterDot = str.slice(dotIndex + 1)
  const combined = beforeDot + afterDot
  const newDotPosition = combined.length - afterDot.length - 2

  if (newDotPosition <= 0) {
    return parseFloat('0.' + combined.padStart(combined.length - newDotPosition, '0'))
  }

  return parseFloat(combined.slice(0, newDotPosition) + '.' + combined.slice(newDotPosition))
}

function multiplyBy100 (numStr) {
  const str = String(numStr)
  const dotIndex = str.indexOf('.')

  if (dotIndex === -1) {
    return parseFloat(str + '00')
  }

  const beforeDot = str.slice(0, dotIndex)
  const afterDot = str.slice(dotIndex + 1)

  if (afterDot.length >= 2) {
    return parseFloat(beforeDot + afterDot.slice(0, 2) + '.' + afterDot.slice(2))
  } else if (afterDot.length === 1) {
    return parseFloat(beforeDot + afterDot + '0')
  } else {
    return parseFloat(beforeDot + '00')
  }
}

export function convertToBackend (value, type) {
  let newValue = value

  if (type === 'time') {
    newValue = moment(value).format('HH:mm')
    if (newValue === 'Invalid date') {
      newValue = null
    }
  }

  if (type === 'date') {
    newValue = moment(value).format('YYYY-MM-DD')
    if (newValue === 'Invalid date') {
      newValue = null
    }
  }

  if (type === 'number') {
    newValue = parseFloat(value)
  }

  if (type === 'percent') {
    const num = parseFloat(value)
    if (isNaN(num)) {
      newValue = null
    } else {
      newValue = divideBy100(value)
    }
  }

  if (type === 'money') {
    const num = parseFloat(value)
    if (isNaN(num)) {
      newValue = null
    } else {
      newValue = multiplyBy100(value)
    }
  }

  return newValue
}

export function validateValue (value, type) {

  if (type === 'money') {
    return moment(value, 'HH:mm').toDate()
  }

  return value
}
